import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=245e04a4&scoped=true&"
import script from "./BaseDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BaseDropdown.vue?vue&type=style&index=0&id=245e04a4&lang=scss&scoped=true&"
import style1 from "./BaseDropdown.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245e04a4",
  null
  
)

export default component.exports